import { z } from 'zod';

import { LOGIN_UNAUTHORIZED_ERROR_CODES } from '../consts';

// The login 401 body carries the code under an `errors` wrapper, which the api-client's
// `UnauthorizedErrorSchema` keeps as an optional field, so the wrapper is still present
// here whether or not the body also has a top-level `message`.
const EmailNotVerifiedErrorSchema = z.object({
  errors: z.object({
    code: z.literal(LOGIN_UNAUTHORIZED_ERROR_CODES.EMAIL_NOT_VERIFIED)
  })
});

/** True when the login 401 payload says the account's email address is unverified. */
export const isEmailNotVerifiedError = (error: unknown) => EmailNotVerifiedErrorSchema.safeParse(error).success;
